import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12 1.5v21M1.5 12h21",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgPlus;
